import React from 'react';
import { useNavigate } from 'react-router-dom';

interface ErrorStateProps {
  error?: string;
  onBack?: () => void;
}

const ErrorState: React.FC<ErrorStateProps> = ({ error = 'An error occurred', onBack }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate('/manage-coach');
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold text-foreground">View Coach Details</h2>
        <button
          onClick={handleBack}
          className="px-4 py-2 bg-card border border-border rounded-md text-foreground hover:bg-background-secondary transition-colors"
        >
          ← Back to Coaches
        </button>
      </div>
      <div className="bg-card border border-card-border rounded-lg p-6 shadow-card">
        <div className="text-center text-red-600">{error}</div>
      </div>
    </div>
  );
};

export default ErrorState;
